// extracted by mini-css-extract-plugin
module.exports =  {"railway-item":"_0bc5e8de02--railway-item--MMHsW","travel-info":"_0bc5e8de02--travel-info--U8AZW"};